import React, { useState, useContext } from "react";
import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  ContentBlock,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import {
  PAconnectorGTM,
  PAconnectorGA,
  PAconnectorFB,
  PAconnectorPN,
  PAconnectorTW,
} from "../PAconnectors";




import PAContentBlock from "../PAContentBlock";
// import { applyEasing } from '../sb/js/webflow';


export default function PApsSetting() {
  return (
    <div
    // className="xsui-content-block xsui-content-block--appearance-primary"
    >




    {/* <a
      className="ui-navigation__item"
      aria-current="false"
      href="/15924/projects/44057/payments"
    >
      Payment methods
    </a>
    <a className="ui-navigation__item">Gateways</a>
    <a className="ui-navigation__item">
      PayRank settings
    </a>
    <a className="ui-navigation__item">Sharing</a>
    <a className="ui-navigation__item ui-navigation__item--active">
      Settings
    </a> */}




      <div className="xsui-content-block__entry">
        {/* <div className="xsui-head xsui-head--appearance-separated xsui-head--indentation-xlg xsui-head--align-left">
          <div className="xsui-head__title">Settings</div>
        </div> */}

        <form
          style={{ display: "flex", flex: "1 1 0%", flexDirection: "column" }}
        >
          <PAContentBlock title="Checkout" border={true}>
            <div className="ui-form__section__content">
              <div className="payments-checkout-status-msg">
                <div className="submit-status submit-status--alert">
                  <span>
                    To enable Checkout, you need to set up{" "}
                    <a
                      aria-current="false"
                      href="/15924/projects/44057/edit/webhooks/checkout"
                    >
                      webhooks
                    </a>{" "}
                    first.
                  </span>
                </div>
              </div>
              <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
                <div className="xsui-form-group__entry">
                  <div className="ui-form__input-group ui-form__input-group--spaced">
                    <div className="xsui-switch-container">
                      <div className="xsui-switch xsui-switch--align-right xsui-switch--disabled">
                        <label data-id="ps_toggle_checkout" data-value="false">
                          <input
                            name="ps_toggle_checkout"
                            className
                            type="checkbox"
                            disabled
                            defaultValue="false"
                          />
                          <div className="xsui-switch__status xsui-switch__status--disabled">
                            <div className="xsui-switch__status__off">Off</div>
                            <div className="xsui-switch__status__on">On</div>
                          </div>
                        </label>
                        <div className="xsui-switch__description xsui-switch__description--align-right" />
                      </div>
                    </div>
                    <div className="ui-form__input-description">
                      <div className="ui-form__input-description__title">
                        <span>Checkout</span>
                      </div>
                      <p>
                        <span>
                          If your game already has an in-game store, checking
                          this item will enable calculating the price on your
                          side and then transmitting the purchase data to the
                          Pay Station UI.{" "}
                          <a
                            href="https://developers.xsolla.com/doc/pay-station/"
                            target="_blank"
                            data-id="ps_configuration_checkout_learn-more"
                          >
                            Learn more
                          </a>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </PAContentBlock>

          <PAContentBlock title="Additional settings" border={true}>
            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-lg">
              <div className="xsui-form-group__label">
                Abbreviated project name
                <div className="xsui-tooltip xsui-tooltip--offset-left">
                  <div
                    className
                    data-tooltipped
                    aria-describedby="tippy-tooltip-84"
                    data-original-title="undefined"
                    style={{ display: "inline" }}
                  >
                    <div className="xsui-tooltip__button" />
                  </div>
                </div>
              </div>
              <div className="xsui-form-group__entry">
                <div style={{ display: "block" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      display: "block"
                    }}
                  >
                    <input
                      name="descriptor"
                      className="xsui-input xsui-input--size-md xsui-input--appearance-primary"
                      type="text"
                      data-id="descriptor"
                      data-value="Xsolla Store"
                      defaultValue="Xsolla Store"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
              <div className="xsui-form-group__entry">
                <div className="ui-form__input-group ui-form__input-group--spaced">
                  <div className="xsui-switch-container">
                    <div className="xsui-switch xsui-switch--align-right">
                      <label data-id="offerwall_enabled" data-value="false">
                        <input
                          name="offerwall_enabled"
                          className
                          type="checkbox"
                          defaultValue="false"
                        />
                        <div className="xsui-switch__status">
                          <div className="xsui-switch__status__off">Off</div>
                          <div className="xsui-switch__status__on">On</div>
                        </div>
                      </label>
                      <div className="xsui-switch__description xsui-switch__description--align-right" />
                    </div>
                  </div>
                  <div className="ui-form__input-description">
                    <div className="ui-form__input-description__title">
                      <span>Offerwall</span>
                    </div>
                    <p>
                      Offerwall allows users to top-up their Xsolla Balances by
                      completing certain tasks. They can later use the bonus to
                      pay for in-game purchases.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
              <div className="xsui-form-group__entry">
                <div className="ui-form__input-group ui-form__input-group--spaced">
                  <div className="xsui-switch-container">
                    <div className="xsui-switch xsui-switch--align-right">
                      <label
                        data-id="is_external_id_required"
                        data-value="false"
                      >
                        <input
                          name="is_external_id_required"
                          className
                          type="checkbox"
                          defaultValue="false"
                        />
                        <div className="xsui-switch__status">
                          <div className="xsui-switch__status__off">Off</div>
                          <div className="xsui-switch__status__on">On</div>
                        </div>
                      </label>
                      <div className="xsui-switch__description xsui-switch__description--align-right" />
                    </div>
                  </div>
                  <div className="ui-form__input-description">
                    <div className="ui-form__input-description__title">
                      <span>Transaction external ID</span>
                    </div>
                    <p>Transaction ID in your system.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
              <div className="xsui-form-group__entry">
                <div className="ui-form__input-group ui-form__input-group--spaced">
                  <div className="xsui-switch-container">
                    <div className="xsui-switch xsui-switch--align-right">
                      <label
                        data-id="user_public_id_enabled"
                        data-value="false"
                      >
                        <input
                          name="user_public_id_enabled"
                          className
                          type="checkbox"
                          defaultValue="false"
                        />
                        <div className="xsui-switch__status">
                          <div className="xsui-switch__status__off">Off</div>
                          <div className="xsui-switch__status__on">On</div>
                        </div>
                      </label>
                      <div className="xsui-switch__description xsui-switch__description--align-right" />
                    </div>
                  </div>
                  <div className="ui-form__input-description">
                    <div className="ui-form__input-description__title">
                      <span>Public user ID</span>
                    </div>
                    <p>
                      Enables user verification via public user ID for payments
                      through cash kiosks.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </PAContentBlock>

          <PAContentBlock title="Apps" border={true}>


          <div
                style={{
                  display: "grid",
                  // gridTemplateColumns: "repeat(2, 1fr)",
                  gridTemplateColumns: "repeat(2, 48%)",
                  // gridTemplateRows: '200px',
                  gridColumnGap: "4%",
                  gridRowGap: "16px"
                  // width: "100%"
                }}
              >
                <PAconnectorGA>
                  Tasks and reports website traffic
                </PAconnectorGA>

                <PAconnectorFB>
                  Add the Facebook pixel to your website to measure the impact
                  of your ads.
                </PAconnectorFB>

              </div>


          </PAContentBlock>


          <PAContentBlock title="Customization" border={true}>
            <FormGroup label="Transactional emails">
              <Button appearance="secondary">Customize emails</Button>
            </FormGroup>
          </PAContentBlock>


          <PAContentBlock title="Redirect policy" border={true}>
            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
              <div className="xsui-form-group__label">
                Return URL
                <div className="xsui-tooltip xsui-tooltip--offset-left">
                  <div
                    className
                    data-tooltipped
                    aria-describedby="tippy-tooltip-85"
                    data-original-title="undefined"
                    style={{ display: "inline" }}
                  >
                    <div className="xsui-tooltip__button" />
                  </div>
                </div>
              </div>
              <div className="xsui-form-group__entry">
                <div style={{ display: "block" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      display: "block"
                    }}
                  >
                    <input
                      name="return_url"
                      placeholder="https://example.com/return"
                      className="xsui-input xsui-input--size-md xsui-input--appearance-primary"
                      type="text"
                      data-id="return_url"
                      data-value
                      defaultValue
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
              <div className="xsui-form-group__label">
                Redirect conditions
                <div className="xsui-tooltip xsui-tooltip--offset-left">
                  <div
                    className
                    data-tooltipped
                    aria-describedby="tippy-tooltip-86"
                    data-original-title="undefined"
                    style={{ display: "inline" }}
                  >
                    <div className="xsui-tooltip__button" />
                  </div>
                </div>
              </div>
              <div className="xsui-form-group__entry">
                <div className="xsui-select">
                  <div className="xsui-dropdown">
                    <div style={{ display: "block" }}>
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          display: "block"
                        }}
                      >
                        <button
                          name="autoredirect_from_status_page"
                          value="None — do not redirect"
                          placeholder="Not selected"
                          className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only"
                          type="button"
                          data-id="autoredirect_from_status_page"
                          data-value="None — do not redirect"
                        >
                          None — do not redirect
                        </button>
                        <div className="xsui-input__icon">
                          <i
                            className="xsui-icon xsui-icon-dropdown-select"
                            style={{ fontSize: 24, color: "inherit" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div />
                  </div>
                </div>
              </div>
            </div>

            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
              <div className="xsui-form-group__label">
                Delay, in seconds
                <div className="xsui-tooltip xsui-tooltip--offset-left">
                  <div
                    className
                    data-tooltipped
                    aria-describedby="tippy-tooltip-87"
                    data-original-title="undefined"
                    style={{ display: "inline" }}
                  >
                    <div className="xsui-tooltip__button" />
                  </div>
                </div>
              </div>
              <div className="xsui-form-group__entry">
                <div style={{ maxWidth: 128 }}>
                  <div style={{ display: "block" }}>
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        display: "block"
                      }}
                    >
                      <input
                        min={0}
                        name="autoredirect_from_status_page_in_seconds"
                        className="xsui-input xsui-input--size-md xsui-input--appearance-primary"
                        type="number"
                        data-id="autoredirect_from_status_page_in_seconds"
                        data-value={0}
                        defaultValue={0}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-lg">
              <div className="xsui-form-group__label">
                Status for manual redirection
                <div className="xsui-tooltip xsui-tooltip--offset-left">
                  <div
                    className
                    data-tooltipped
                    aria-describedby="tippy-tooltip-88"
                    data-original-title="undefined"
                    style={{ display: "inline" }}
                  >
                    <div className="xsui-tooltip__button" />
                  </div>
                </div>
              </div>
              <div className="xsui-form-group__entry">
                <div className="xsui-select">
                  <div className="xsui-dropdown">
                    <div style={{ display: "block" }}>
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          display: "block"
                        }}
                      >
                        <button
                          name="status_page_show_return_to_game_link"
                          value="Successful"
                          placeholder="Not selected"
                          className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only"
                          type="button"
                          data-id="status_page_show_return_to_game_link"
                          data-value="Successful"
                        >
                          Successful
                        </button>
                        <div className="xsui-input__icon">
                          <i
                            className="xsui-icon xsui-icon-dropdown-select"
                            style={{ fontSize: 24, color: "inherit" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div />
                  </div>
                </div>
              </div>
            </div>

            <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
              <div className="xsui-form-group__entry">
                <div className="xsui-collapse xsui-collapse--collapsed">
                  <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                    <div className="xsui-form-group__label">
                      Redirect button caption | English
                      <div className="xsui-tooltip xsui-tooltip--offset-left">
                        <div
                          className
                          data-tooltipped
                          aria-describedby="tippy-tooltip-89"
                          data-original-title="undefined"
                          style={{ display: "inline" }}
                        >
                          <div className="xsui-tooltip__button" />
                        </div>
                      </div>
                    </div>
                    <div className="xsui-form-group__entry">
                      <div style={{ display: "block" }}>
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            display: "block"
                          }}
                        >
                          <input
                            name="status_page_return_to_game_link_name[en]"
                            className="xsui-input xsui-input--size-md xsui-input--appearance-primary"
                            type="text"
                            data-id="status_page_return_to_game_link_name[en]"
                            data-value
                            defaultValue
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="ReactCollapse--collapse"
                    style={{ overflow: "hidden", height: 0 }}
                  >
                    <div className="ReactCollapse--content">
                      <div className="xsui-collapse__entry">
                        <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
                          <div className="xsui-form-group__label">
                            Redirect button caption | Russian
                          </div>
                          <div className="xsui-form-group__entry">
                            <div style={{ display: "block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  display: "block"
                                }}
                              >
                                <input
                                  name="status_page_return_to_game_link_name[ru]"
                                  className="xsui-input xsui-input--size-md xsui-input--appearance-primary"
                                  type="text"
                                  data-id="status_page_return_to_game_link_name[ru]"
                                  data-value
                                  defaultValue
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="xsui-button xsui-button--appearance-flatten xsui-button--size-md xsui-button__icon"
                    type="button"
                  >
                    <div className="xsui-button__wrapper">
                      <div className="xsui-button__content">
                        <i
                          className="xsui-icon xsui-icon-expand"
                          style={{ fontSize: 24, color: "inherit" }}
                        />
                        1 more language
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </PAContentBlock>

          <div className="xsui-form-footer xsui-form-footer--down">
            <div className="xsui-form-footer__entry">
              <a className aria-current="true" href="/15924/projects/44057">
                <button
                  className="xsui-button xsui-button--appearance-outline xsui-button--size-md"
                  type="button"
                >
                  <div className="xsui-button__wrapper">
                    <div className="xsui-button__content">Cancel</div>
                  </div>
                </button>
              </a>
              <button
                className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                type="submit"
              >
                <div className="xsui-button__wrapper">
                  <div className="xsui-button__content">Save</div>
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
